import api from "api/api"

export const GET_ORDER_ITEMS_LOCATIONS = '[ORDER_ITEMS_LOCATIONS] GET_ORDER_ITEMS_LOCATIONS'
export const GET_ORDER_ITEMS_LOCATIONS_LOADING = '[ORDER_ITEMS_LOCATIONS] GET_ORDER_ITEMS_LOCATIONS_LOADING'

export function getOrderItemsLocations(orderId, storeId = null) {
  return async (dispatch) => {
    dispatch({
      type: GET_ORDER_ITEMS_LOCATIONS_LOADING,
      payload: true
    })

    try {
      const query = storeId ? `?storeId=${storeId}` : ''
      const response = await api.get(`/order-items-locations/${orderId}${query}`)
      dispatch({
        type: GET_ORDER_ITEMS_LOCATIONS,
        payload: response.data.data
      })
    } catch (error) {
      console.error(GET_ORDER_ITEMS_LOCATIONS, error)
    } finally {
      dispatch({
        type: GET_ORDER_ITEMS_LOCATIONS_LOADING,
        payload: false
      })
    }
  }
}
